import { cn } from '@april9au/react-common/utils';

import { SectionHeader } from './section-header';

export type SuburbPostcode = {
  suburb: string;
  postcode: string;
};

/** A-Z suburb/postcode directory, laid out in responsive columns. Reusable for any local area reference page. */
export function PostcodeListSection({
  id,
  eyebrow,
  heading,
  description,
  entries,
  className,
}: {
  id?: string;
  eyebrow?: string;
  heading: string;
  description?: string;
  entries: Array<SuburbPostcode>;
  className?: string;
}) {
  return (
    <section id={id} className={cn('section', className)}>
      <div className="container">
        <SectionHeader eyebrow={eyebrow} heading={heading} description={description} align="left" className="mb-12" />

        <div className="columns-1 gap-x-12 sm:columns-2 lg:columns-3">
          {entries.map((entry) => (
            <div key={entry.suburb} className="mb-3 flex items-baseline justify-between gap-4 border-b pb-2 break-inside-avoid">
              <span className="text-body">{entry.suburb}</span>
              <span className="text-gold font-semibold tabular-nums">{entry.postcode}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
